module.exports = __webpack_public_path__ + "static/media/bgShare1.34bb3667.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare1.png
// module id = 355
// module chunks = 0